<div *ngIf="next_maintenance" class="d-flex flex-row vi-gap-16">
    Due to scheduled maintenance the application won't be available
    from {{ next_maintenance.start_date | date : 'medium' }}
    until {{ next_maintenance.end_date | date : 'medium' }}
  </div>
  
  
  